<script lang="ts">
import Warning from "~icons/ph/warning-duotone"
let {
  class: className = "",
  ...props
} = $props()
</script>
<Warning class="{className} [&_path[opacity]]:fill-warning-400 [&_path[opacity]]:opacity-100" {...props} />